import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-stamp-receipt',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stamp-receipt.component.html',
  styleUrl: './stamp-receipt.component.css',
})
export class StampReceiptComponent {}
